module.exports = __webpack_public_path__ + "media/reskin-images/img--bespoke-solutions-02428821.jpeg";